import React, {useEffect}  from "react";
import _ from 'lodash';
import { IconButton, Modal, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { TextModal } from "./textModal"
import TextHistoryModal from './TextHistory';
import { EmailModal } from "./emailModal"
import { ItinModal } from "./itinModal"
import { useDispatch, useSelector } from "react-redux";
import { resetTextHistory, loadPaxInfo, doneSendingMessage, resetEmailStatus, resetTextStatus, resetEmailHistory } from "../../store/departures";
import EmailHistoryModal from "./EmailHistory";

// NOTE // this component handles the email, text, and itinerary modals
export const PaxMenu = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const modalClasses = props.modalClasses;
  const [openTextModal, setOpenTextModal] = React.useState(false);
  const [openTextHistory, setTextHistoryModal] = React.useState(false);
  const [openEmailModal, setOpenEmailModal] = React.useState(false);
  const [openEmailHistory, setOpenEmailHistory] = React.useState(false)
  const [openItinModal, setOpenItinModal] = React.useState(false)
  const key = props.row.key
  const flight = props.row
  const date = props.date
  const dispatch = useDispatch()
  const tailItems = useSelector(state => state.entities.departures.paxInfo)
  let tailItem = tailItems.find(t => t.key == key)
  // alert(JSON.stringify(props.row));
  useEffect(() => {
    dispatch(loadPaxInfo(key));
  }, []);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleTextModal = (bool) => {
    setOpenTextModal(bool)
    dispatch(resetTextStatus())
  }

  const handleEmailModal = (bool) => {
    setOpenEmailModal(bool)
    dispatch(resetEmailStatus())
  }

  const handleEmailHistory = (bool) => {
    setOpenEmailHistory(bool)
    dispatch(resetEmailHistory())
  }

  const handleItineraryModal = (bool) => {
    setOpenItinModal(bool)
    dispatch(resetEmailStatus())
  }

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleCloseHistory = () => {
    setTextHistoryModal(false)
    dispatch(resetTextHistory())
  }


  return (
    <div>
      <IconButton
        aria-label="more" 
        aria-controls="simple-menu"
        aria-haspopup="true"
        size="small"
        onClick={handleOpenMenu}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={openMenu}
        onClose={handleCloseMenu}
        PaperProps={{
          style: {
            maxHeight: '150px',
            width: '20ch',
          },
        }}
      >
        <MenuItem onClick={() => {handleTextModal(true)}}>Text Pax</MenuItem>
        <MenuItem onClick={() => {setTextHistoryModal(true)}}>TextHistory</MenuItem>
        <MenuItem onClick={() => {handleEmailModal(true)}}>Email Pax</MenuItem>
        <MenuItem onClick={() => {handleEmailHistory(true)}}>Email History</MenuItem>
        <MenuItem onClick={() => {handleItineraryModal(true)}}>Send Itinerary</MenuItem>
      </Menu>
      <Modal
        open={openTextModal}
        onClose={() => {handleTextModal(false)}}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <TextModal paxInfo={tailItem} closeModal={handleTextModal} />
      </Modal>
      <Modal
        open={openTextHistory}
        onClose={() => {handleCloseHistory()}}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{overflow: 'scroll'}}
      >
        <TextHistoryModal paxInfo={tailItem} flight={flight} date={date} closeModal={handleCloseHistory} modalClasses={modalClasses} />
      </Modal>
      <Modal
        open={openEmailModal}
        onClose={() => {handleEmailModal(false)}}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <EmailModal paxInfo={tailItem} closeModal={handleEmailModal} />
      </Modal>
      <Modal
        open={openEmailHistory}
        onClose={() => {handleEmailHistory(false)}}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <EmailHistoryModal paxInfo={tailItem} closeModal={handleEmailHistory} />
      </Modal>
      <Modal
        open={openItinModal}
        onClose={() => {handleItineraryModal(false)}}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <ItinModal paxInfo={tailItem} closeModal={handleItineraryModal} />
      </Modal>
    </div>
  )
}